function menuModule() {
    this.init = function () {
        var $menu = $(".fixed-on-scroll");
        var is_product_page = false;
        if ($(".product-top-bar").length) {
            $menu = $(".product-top-bar");
            is_product_page = true;
        }

        if (!$menu.length) {
            return;
        }

        var $header = $("#header");
        var override = parseInt($menu.attr("data-scroll"), 10);
        var threshold = 0;

        // data-scroll overrides; without it the bar appears once the header
        // has scrolled out of view, whatever its height on this page.
        function measureThreshold() {
            if (override > 0) {
                return override;
            }
            if ($header.length) {
                return $header.offset().top + $header.outerHeight();
            }
            return 0;
        }

        function toggleMenu() {
            // Once the bar is fixed it leaves the document flow and the header
            // collapses, so its bottom is only a usable threshold while the bar
            // is still static. Measure then and keep that value while fixed,
            // otherwise the threshold drops to ~0 and the bar never lets go of
            // the top of the page (MM-25926).
            if (!$menu.hasClass("show-scrollable")) {
                threshold = measureThreshold();
            }

            var scroll = $(window).scrollTop();
            if (scroll < threshold) {
                $menu.removeClass("show-scrollable");
                if (is_product_page) {
                    $menu.hide();
                }
            } else if (!$menu.hasClass("show-scrollable")) {
                $menu.addClass("show-scrollable").hide().fadeIn();
            }
        }

        var ticking = false;
        $(window).on("scroll resize", function () {
            if (!ticking) {
                ticking = true;
                window.requestAnimationFrame(function () {
                    toggleMenu();
                    ticking = false;
                });
            }
        });

        toggleMenu();
    };
}

module.exports = menuModule;
